import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';

const ExcluirSala = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [sala, setSala] = useState(null);

  useEffect(() => {
    const fetchSala = async () => {
      try {
        const response = await authFetch(`room/${id}`);
        if (!response.ok) throw new Error('Erro ao carregar sala');
        const data = await response.json();
        setSala(data);
      } catch (error) {
        showNotification('danger', 'Erro ao carregar sala');
        navigate('/Salas');
      }
    };

    fetchSala();
  }, [id, navigate, showNotification]);

  const handleDelete = async () => {
    setLoading(true);

    try {
      const response = await authFetch(`room/${id}`, {
        method: 'DELETE'
      });

      if (!response.ok) throw new Error('Erro ao excluir sala');

      showNotification('success', 'Sala excluída com sucesso!');
      navigate('/Salas');
    } catch (error) {
      showNotification('danger', 'Erro ao excluir sala');
      setLoading(false);
    }
  };

  if (!sala) return null;

  return (
    <div className="content">
      <h3 className="font-weight-bolder mb-3">Excluir Sala</h3>
      <div className="card">
        <div className="card-body p-3">
          <p className="mb-4">
            Tem certeza que deseja excluir a sala <strong>{sala.name}</strong>?
          </p>
          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate('/Salas')}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleDelete}
              disabled={loading}
            >
              {loading ? 'Excluindo...' : 'Excluir'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExcluirSala; 